import {
  StyledPlayerLabel,
  PlayerLabelName,
  PlayerLabelXp
} from './PlayerLabel.styled';

const PlayerLabel = ({ name, xp, isNpc = false, you = true }) => {
  return (
    <StyledPlayerLabel $you={you}>
      <PlayerLabelName $you={you} >{name}</PlayerLabelName>
      {!isNpc && <PlayerLabelXp>{xp} xp</PlayerLabelXp>}
    </StyledPlayerLabel>
  );
};

export default PlayerLabel;
